<template>
  <div class="ajax-form">
    <input type="hidden" name="category" value="1" />
    <div class="row">
      <div class="col-12">
        <div class="page__head-title page__head-title--orange">
          <div class="page__head-title__text page__head-title__text--orange">
            Assurance Tous Risques
          </div>
          <div class="page__head-title__notice">(* champs obligatoires)</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form_ttl">Informations sur le Camping-car à assurer :</div>
      </div>
      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">
            Camping car neuf
          </div>
          <div
            class="form__item__input-wrapper form__item__input-wrapper--checkbox"
          >
            <input
              v-model="garantieCampingCar.is_new"
              type="radio"
              value="Oui"
              checked
            />
            Oui
            <input
              v-model="garantieCampingCar.is_new"
              type="radio"
              value="Non"
            />
            Non
          </div>
        </div>
      </div>
      <!--Immatriculation-->
      <div class="col-12">
        <div class="form__item relative">
          <div
            class="form__item__label form__item__label"
            :class="{ 'form__item__label--required': !isNewCar }"
          >
            Immatriculation
          </div>
          <div
            class="form__item__input-wrapper"
            :class="{
              'input-addon': existingVehicleFound || isVehicleSearching
            }"
          >
            <input
              type="text"
              id="immatriculation"
              v-model="garantieCampingCar.immatriculation"
              @input="searchByRegNumber"
              class="input_n"
              :class="{ input_red_shadow: hasError('immatriculation') }"
            />

            <div
              class="form__item__input-wrapper--loader"
              v-if="isVehicleSearching"
            >
              <Preloader :wrapper-height="'20px'" :size="'20px'" />
            </div>
            <!-- <button
              type="button"
              @click="fillTheFieldsByImmatriculation"
              class="form_bt form_confirm_button form__item__submit__button--small-helper"
              v-if="existingVehicleFound && !isVehicleSearching"
            >
              Compléter
            </button> -->
          </div>
          <div class="tooltip__wrap">
            <div class="tooltip__wrap--icon"></div>

            <div class="tooltip__wrap--text">
              <div class="tooltip__wrap--text--notice">
                Veuillez saisir l'immatriculation du véhicule en lettres
                majuscules et séparés par un trait d'union. Exemple: AF-785-HT
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--num_serie-->
      <template v-if="acceptedVehicleResult || isNewCar">
        <CustomTextInput
          title="Numéro de série"
          :disabledFlag="acceptedVehicleResult && !isNewCar"
          :val.sync="garantieCampingCar.num_serie"
          :showError="hasError('num_serie')"
        />
      </template>
      <CustomTextInput
        title="Marque du porteur"
        :val.sync="garantieCampingCar.marque_porteur"
        :showError="hasError('marque_porteur')"
        :disabledFlag="acceptedVehicleResult && !isNewCar"
      />
      <CustomTextInput
        title="Modèle du porteur"
        :val.sync="garantieCampingCar.modele_porteur"
        :showError="hasError('modele_porteur')"
        :disabledFlag="acceptedVehicleResult && !isNewCar"
      />
      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">
            Date de 1&egrave;re mise en circulation
          </div>
          <div
            class="form__item__input-wrapper form__item__input-wrapper--date currency-datepicker"
          >
            <CustomDatepicker
              :date.sync="circulationDateInput"
              :has-error="hasError('circulation_date')"
              :disabled="acceptedVehicleResult && !isNewCar"
            />
          </div>
        </div>
      </div>
      <CustomTextInput
        title="Valeur"
        :val.sync="garantieCampingCar.valeur"
        :showError="hasError('valeur')"
      />

      <!--Puissance Fiscale-->
      <template v-if="isNewCar">
        <CustomTextInput
          title="Puissance Fiscale"
          :disabledFlag="acceptedVehicleResult && !isNewCar"
          :val.sync="garantieCampingCar.puis_fisc"
          :showError="hasError('puis_fisc')"
        />
      </template>
      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">
            Poids Total Autorisé En Charge
          </div>
          <div class="form__item__input-wrapper">
            <select
              v-model="garantieCampingCar.ptc"
              class="select_n"
              id="ptc"
              :class="{ input_red_shadow: hasError('ptc') }"
              :disabled="acceptedVehicleResult && !isNewCar"
            >
              <option v-for="option in ptcOptions" :value="option.value">{{
                option.name
              }}</option>
            </select>
          </div>
        </div>
      </div>

      <!--<div class="col-12">-->
      <!--<div class="form__item">-->
      <!--<div class="form__item__label form__item__label&#45;&#45;required">Assistance Souhaitée</div>-->
      <!--<div class="form__item__input-wrapper">-->
      <!--<select v-model="garantieCampingCar.assistance" class="select_n" id="assistance"-->
      <!--:class="{input_red_shadow: hasError('assistance')}">-->
      <!--<option v-for="option in assistanceOptions" :value="option.value">{{option.name}}</option>-->
      <!--</select>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">
            Le propriétaire a été assuré pendant plus de 24 mois
          </div>
          <div
            class="form__item__input-wrapper form__item__input-wrapper--checkbox"
          >
            <input
              v-model="garantieCampingCar.assure"
              type="radio"
              value="Oui"
              checked
            />
            Oui
            <input
              v-model="garantieCampingCar.assure"
              type="radio"
              value="Non"
            />
            Non
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">
            Date d’effet
          </div>
          <div
            class="form__item__input-wrapper form__item__input-wrapper--date currency-datepicker"
          >
            <CustomDatepicker
              :date.sync="effectiveDateInput"
              :has-error="hasError('effective_date')"
            />
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form_ttl_first">
          Informations sur le propriétaire du véhicule:
        </div>
      </div>
      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label">Civilit&eacute;</div>
          <div class="form__item__input-wrapper">
            <select v-model="garantieCampingCar.civilite">
              <option value="0" selected="selected">M</option>
              <option value="1">Mlle</option>
              <option value="2">Mme</option>
              <option value="3">Société</option>
            </select>
          </div>
        </div>
      </div>

      <CustomTextInput
        title="Nom"
        :val.sync="garantieCampingCar.nom"
        :showError="hasError('nom')"
      />

      <template v-if="garantieCampingCar.civilite == 3">
        <CustomTextInput
          title="Nom du signataire"
          :val.sync="garantieCampingCar.name_of_signatory"
          :showError="hasError('name_of_signatory')"
        />
      </template>
      <template v-else>
        <CustomTextInput
          title="Prénom"
          :val.sync="garantieCampingCar.prenom"
          :showError="hasError('prenom')"
        />
      </template>

      <CustomTextInput
        title="Adresse"
        :val.sync="garantieCampingCar.adresse"
        :showError="hasError('adresse')"
      />
      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">
            Code postal
          </div>
          <div class="form__item__input-wrapper">
            <input
              type="text"
              v-model="garantieCampingCar.cp"
              maxlength="5"
              class="input_n"
              :class="{ input_red_shadow: hasError('cp') }"
            />
          </div>
        </div>
      </div>
      <CustomTextInput
        title="Ville"
        :val.sync="garantieCampingCar.ville"
        :showError="hasError('ville')"
      />
      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">
            Téléphone
          </div>
          <div
            class="form__item__input-wrapper"
            :class="{
              'input-addon': existingCustomerFound || isClientSearching
            }"
          >
            <input
              type="text"
              v-model="garantieCampingCar.tel"
              @input="searchClient"
              maxlength="10"
              class="input_n"
              :class="{ input_red_shadow: hasError('tel') }"
            />

            <div
              class="form__item__input-wrapper--loader"
              v-if="isClientSearching"
            >
              <Preloader :wrapper-height="'20px'" :size="'20px'" />
            </div>
            <button
              type="button"
              @click="fillTheFields"
              class="form_bt form_confirm_button form__item__submit__button--small-helper"
              v-if="existingCustomerFound && !isClientSearching"
            >
              Compléter
            </button>
          </div>
        </div>
      </div>
      <!--<div class="col-12">-->
      <!--<div class="form__item">-->
      <!--<div class="form__item__label">Fax</div>-->
      <!--<div class="form__item__input-wrapper">-->
      <!--<input type="text" v-model="garantieCampingCar.fax" maxlength="10" class="input_n"-->
      <!--:class="{input_red_shadow: hasError('fax')}">-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Email</div>
          <div class="form__item__input-wrapper">
            <input
              type="email"
              v-model="garantieCampingCar.email"
              class="input_n"
              :class="{ input_red_shadow: hasError('email') }"
            />
            <span style="color: red;"
              >Renseignez impérativement une adresse électronique valide du
              client</span
            >
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">
            Date De Naissance
          </div>
          <div
            class="form__item__input-wrapper form__item__input-wrapper--date currency-datepicker"
          >
            <CustomDatepicker
              :date.sync="dateDeNaissanceInput"
              :has-error="hasError('date_de_naissance')"
            />
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">
            Situation familiale
          </div>
          <div class="form__item__input-wrapper">
            <select v-model="garantieCampingCar.situation_famille">
              <option value="0" selected="selected">Célibataire</option>
              <option value="1">Marié(e)</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">
            Profession
          </div>
          <div class="form__item__input-wrapper">
            <select v-model="garantieCampingCar.profession">
              <option value="0" selected="selected"
                >Choisissez une profession...</option
              >
              <option value="1">Artisant/commerçant</option>
              <option value="2">Exploitant agricole</option>
              <option value="3">Profession libérale</option>
              <option value="4">Chef d'entreprise</option>
              <option value="5">Salarié</option>
              <option value="6">Fonctionnaire</option>
              <option value="7">VRP</option>
              <option value="8">Etudiant</option>
              <option value="9">Sans profession</option>
              <option value="10">Retraité</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">
            Date De Permis
          </div>
          <div
            class="form__item__input-wrapper form__item__input-wrapper--date currency-datepicker"
          >
            <CustomDatepicker
              :date.sync="dateDePermisInput"
              :has-error="hasError('date_de_permis')"
            />
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Bonus</div>
          <div class="form__item__input-wrapper">
            <select v-model="garantieCampingCar.bonus">
              <option value="0" selected="selected"
                >0.50 soit 50% de bonus</option
              >
              <option value="1">0.51 soit 49% de bonus</option>
              <option value="2">0.52 soit 48% de bonus</option>
              <option value="3">0.53 soit 47% de bonus</option>
              <option value="4">0.54 soit 46% de bonus</option>
              <option value="5">0.55 soit 45% de bonus</option>
              <option value="6">0.56 soit 44% de bonus</option>
              <option value="7">0.57 soit 43% de bonus</option>
              <option value="8">0.58 soit 42% de bonus</option>
              <option value="9">0.59 soit 41% de bonus</option>
              <option value="10">0.60 soit 40% de bonus</option>
              <option value="11">0.61 soit 39% de bonus</option>
              <option value="12">0.62 soit 38% de bonus</option>
              <option value="13">0.63 soit 37% de bonus</option>
              <option value="14">0.64 soit 36% de bonus</option>
              <option value="15">0.65 soit 35% de bonus</option>
              <option value="16">0.66 soit 34% de bonus</option>
              <option value="17">0.67 soit 33% de bonus</option>
              <option value="18">0.68 soit 32% de bonus</option>
              <option value="19">0.69 soit 31% de bonus</option>
              <option value="20">0.70 soit 30% de bonus</option>
              <option value="21">0.71 soit 29% de bonus22</option>
              <option value="22">0.72 soit 28% de bonus</option>
              <option value="23">0.73 soit 27% de bonus</option>
              <option value="24">0.74 soit 26% de bonus</option>
              <option value="25">0.75 soit 25% de bonus</option>
              <option value="26">0.76 soit 24% de bonus</option>
              <option value="27">0.77 soit 23% de bonus</option>
              <option value="28">0.78 soit 22% de bonus</option>
              <option value="29">0.79 soit 21% de bonus</option>
              <option value="30">0.80 soit 20% de bonus</option>
              <option value="31">0.81 soit 19% de bonus</option>
              <option value="32">0.82 soit 18% de bonus</option>
              <option value="33">0.83 soit 17% de bonus</option>
              <option value="34">0.84 soit 16% de bonus</option>
              <option value="35">0.85 soit 15% de bonus</option>
              <option value="36">0.86 soit 14% de bonus</option>
              <option value="37">0.87 soit 13% de bonus</option>
              <option value="38">0.88 soit 12% de bonus</option>
              <option value="39">0.89 soit 11% de bonus</option>
              <option value="40">0.90 soit 10% de bonus</option>
              <option value="41">0.91 soit 9% de bonus</option>
              <option value="42">0.92 soit 8% de bonus</option>
              <option value="43">0.93 soit 7% de bonus</option>
              <option value="44">0.94 soit 6% de bonus</option>
              <option value="45">0.95 soit 5% de bonus</option>
              <option value="46">0.96 soit 4% de bonus</option>
              <option value="47">0.97 soit 3% de bonus</option>
              <option value="48">0.98 soit 2% de bonus</option>
              <option value="49">0.99 soit 1% de bonus</option>
              <option value="50">1.00 soit 0% de bonus</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form__item justify-content-center mt-3 mb-3">
          <div class="form__item__submit">
            <Preloader v-if="isSending" />
            <input
              v-else
              type="submit"
              name="Submit"
              value="Envoyer"
              class="form_bt btnSendAjax form_confirm_button form__item__submit__button btn btn-block"
              @click="onSubmit"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 form__item justify-content-center mt-3 mb-3">
        <ValidationErrors :errorsList="errors" />
      </div>
    </div>
  </div>
</template>

<script>
import ValidationErrors from "@/components/Garantie/ValidationErrors";
import garantieFieldsLists from "@/mixins/garantieFieldsLists";
import Preloader from "@/components/Preloader";
import { DEBOUNCE } from "@/mixins/helper";
import { TheMask } from "vue-the-mask";
import CustomDatepicker from "@/components/CustomInputs/CustomDatepicker";
import CustomTextInput from "./CustomTextInput";
import CustomRadioInput from "./CustomRadioInput";

const INITIAL_FIELDS_VALUES = Object.freeze({
  civilite: 0,
  nom: "",
  prenom: "",
  name_of_signatory: "",
  adresse: "",
  cp: "",
  ville: "",
  tel: "",
  fax: "",
  email: "",
  situation_famille: 0,
  profession: 0,
  is_new: "Non",
  code_garage: "",
  garantie: 0,
  duree: 0,
  immatriculation: "",
  // immatriculation_ancien_numero: '',
  marque_porteur: "",
  modele_porteur: "",
  jour_mise_en_circulation: "",
  mois_mise_en_circulation: "",
  annee_mise_en_circulation: "",
  num_serie: "",
  puis_fisc: "",
  // jour_prise_effet: '',
  // mois_prise_effet: '',
  // annee_prise_effet: '',
  // jour_vente: 1,
  // mois_vente: 1,
  // annee_vente: new Date().getFullYear(),
  // jour_livraison: 1,
  // mois_livraison: 1,
  // annee_livraison: new Date().getFullYear(),
  // km_reel: '',
  // km_day: '',
  assistance: 1,
  // finance: 0,
  // finance_name: '',
  // shipping_date: '',
  valeur: "",
  ptc: 0,
  assure: "Oui",
  bonus: 0,
  jour_naissance: "",
  mois_naissance: "",
  annee_naissance: "",
  jour_permis: "",
  mois_permis: "",
  annee_permis: ""
});

const CAR_TYPE_VP = 1;
const CAR_TYPE_VU = 2;
const CAR_TYPE_4X4 = 3;

const CIVILITY_M = 0;
const CIVILITY_MLLE = 1;
const CIVILITY_MME = 2;
const CIVILITY_SOCIETY = 3;

export default {
  name: "DevisEnLigneAssurance",
  components: {
    ValidationErrors,
    Preloader,
    TheMask,
    CustomDatepicker,
    CustomTextInput,
    CustomRadioInput
  },
  mixins: [garantieFieldsLists],
  data() {
    return {
      garantieCampingCar: { ...INITIAL_FIELDS_VALUES },
      errors: {},
      isSending: false,
      searchResult: null,
      isClientSearching: false,
      effectiveDateInput: "",
      shippingDateInput: "",
      circulationDateInput: "",
      dateDeNaissanceInput: "",
      dateDePermisInput: "",
      birstdayDateInput: "",
      isVehicleSearching: false,
      searchVehicleResult: null,
      acceptedVehicleResult: false
    };
  },
  computed: {
    isEditCampingCar() {
      return !!this.$route.params.id;
    },
    existingCustomerFound() {
      return !!this.searchResult;
    },
    existingVehicleFound() {
      return !!this.searchVehicleResult;
    },
    isNewCar() {
      return this.garantieCampingCar.is_new === "Oui";
    },
    durationOptions() {
      if (this.isNewCar) {
        return [
          { value: "0", name: "Choisir une durée..." },
          { value: "4", name: "36 Mois" }
        ];
      }
      return [
        { value: "0", name: "Choisir une durée..." },
        { value: "7", name: "3 Mois" },
        { value: "1", name: "6 Mois" },
        { value: "2", name: "12 Mois" },
        { value: "6", name: "18 Mois" },
        { value: "3", name: "24 Mois" },
        { value: "4", name: "36 Mois" },
        { value: "5", name: "48 Mois" }
      ];
    },
    ptcOptions() {
      return [
        { value: "0", name: "Chosir un PTC..." },
        { value: "1", name: "Inférieur ou égal à 3,5 T" },
        { value: "2", name: "Supérieur à 3,5 T mais inférieur ou égal à 5 T" },
        { value: "3", name: "Supérieur à 5 T" }
      ];
    },
    assistanceOptions() {
      return [
        { value: "1", name: "Aucune" },
        { value: "0", name: "Pack Assistance" },
        { value: "2", name: "SOS Crevaison" },
        { value: "3", name: "SOS Constat" },
        { value: "4", name: "Assistance diagnostic devis mécanique Standard" },
        { value: "5", name: "Assistance diagnostic devis mécanique Platinium" }
      ];
    },
    mechanic_id() {
      return this.$store.state.userInfo.mechanic
        ? this.$store.state.userInfo.mechanic.id
        : "";
    },
    originLoginType() {
      return this.$store.state.userInfo.origin_login || "dynassurances";
    }
  },
  watch: {
    // 'garantieCampingCar.is_new': function () {
    //     let optionsList = this.getListOfDurationOprions();
    //     if (!optionsList.includes(this.garantieCampingCar.duree)) this.garantieCampingCar.duree = '0';
    // },
    // 'garantieCampingCar.garantie': function () {
    //     if (!this.isNewCar) {
    //         let optionsList = this.getListOfDurationOprions();
    //         if (!optionsList.includes(this.garantieCampingCar.duree)) this.garantieCampingCar.duree = '0';
    //     }
    // },
  },
  methods: {
    searchByRegNumber: DEBOUNCE(function(val) {
      this.garantieCampingCar.immatriculation = this.garantieCampingCar.immatriculation.toUpperCase();

      let matched = this.garantieCampingCar.immatriculation.match(
        /(^([0-9]{2,}-[A-Z]{2,}-[0-9]{2,})+$)|(^([A-Z]{2,}-[0-9]{2,}-[A-Z]{2,})+$)/g
      );

      if (matched) {
        let url = "client/registration",
          data = {
            regNumber: this.garantieCampingCar.immatriculation,
            ccar: true
          };
        this.isVehicleSearching = true;
        this.apiPost(url, data, false)
          .then(response => {
            if (response.data.info) {
              this.searchVehicleResult = response.data.info;
              if (this.searchVehicleResult) {
                this.parseVehicleInfo(this.searchVehicleResult);
                this.garantieCampingCar.immatriculationInfo = this.searchVehicleResult;
                // this.searchVehicleResult = null;
              } else {
                this.acceptedVehicleResult = false;
                this.garantieCampingCar.immatriculationInfo = null;
              }
            }
            this.isVehicleSearching = false;
          })
          .catch(error => {
            this.showErrorNotification(error);
            this.isVehicleSearching = false;
            this.acceptedVehicleResult = false;
          });
      }
    }, 1000),
    fillTheFieldsByImmatriculation() {
      if (this.searchVehicleResult) {
        this.parseVehicleInfo(this.searchVehicleResult);
        this.garantieCampingCar.immatriculationInfo = this.searchVehicleResult;
        // this.searchVehicleResult = null;
      } else {
        this.acceptedVehicleResult = false;
        this.garantieCampingCar.immatriculationInfo = null;
      }
    },
    parseVehicleInfo(info) {
      this.acceptedVehicleResult = true;
      /* Car brand */
      if (info.Marque) {
        this.garantieCampingCar.marque_porteur = info.Marque.toLocaleString();
        this.garantieCampingCar.marque_cellule = info.Marque.toLocaleString();
      }

      /* Modele */
      this.garantieCampingCar.modele_porteur = info.Modele
        ? info.Modele.toLocaleString()
        : null;
      this.garantieCampingCar.modele_cellule = info.Modele
        ? info.Modele.toLocaleString()
        : null;
      /* Num serie */
      this.garantieCampingCar.num_serie = info.VIN ? info.VIN : null;

      if (info.PuissFisc) {
        this.garantieCampingCar.puis_fisc = +info.PuissFisc;
      }

      if (info.DateMec) {
        this.circulationDateInput = new Date(info.DateMec);
      }

      if (info.PTR) {
        if (+info.PTR <= 3500) {
          this.garantieCampingCar.ptc = 1;
        } else if (+info.PTR >= 3501 && +info.PTR <= 5000) {
          this.garantieCampingCar.ptc = 2;
        } else if (+info.PTR >= 5001) {
          this.garantieCampingCar.ptc = 3;
        }
      }
    },
    searchClient: DEBOUNCE(function(val) {
      if (this.garantieCampingCar.tel.length > 2) {
        let url = "client/searchOne",
          data = {
            tel: this.garantieCampingCar.tel
          };
        this.isClientSearching = true;
        this.apiGet(url, data, false)
          .then(response => {
            if (response.data.client) {
              this.searchResult = response.data.client;
            }

            this.isClientSearching = false;
          })
          .catch(error => {
            this.showErrorNotification(error);
            this.isClientSearching = false;
          });
      }
    }, 1000),
    fillTheFields() {
      if (this.searchResult) {
        this.parseClientInfo(this.searchResult);
        this.searchResult = null;
      }
    },
    serializeData() {
      this.garantieCampingCar.mechanic_id = this.mechanic_id;
      //needs to update with flexibility logic
      this.garantieCampingCar.category = 1;
      this.garantieCampingCar.valeur = this.garantieCampingCar.valeur
        ? +this.garantieCampingCar.valeur.toString().replace(",", ".")
        : "";
      switch (this.originLoginType) {
        case "assur_cc":
          this.garantieCampingCar.origin = "assur-campingcar";
          break;
        case "garanties_mechanics":
          this.garantieCampingCar.origin = "garanties-mechanics";
          break;
        case "dynassurances":
          this.garantieCampingCar.origin = "dynassurances";
          break;
      }
      return this.garantieCampingCar;
    },
    onSubmit(event) {
      this.garantieCampingCar.immatriculation = this.garantieCampingCar
        .immatriculation
        ? this.garantieCampingCar.immatriculation.toUpperCase()
        : "";
      this.validateEffectiveDate();
      this.validateCirculationDate();
      this.validateNaissanceDate();
      this.validatePermisDate();
      this.isSending = true;
      let url = "garantie/assurance-partner",
        data = this.serializeData();
      if (this.isEditCampingCar) {
        url = "garantie/assurance-partner/" + this.$route.params.id + "/edit";
      }
      this.apiPostFormData(url, data)
        .then(response => {
          this.isSending = false;
          this.errors = {};
          console.log(response.data);
          // if (response.data.calcQuotes)
          // this.$store.dispatch('updateCalcGaranties', response.data.calcQuotes);
          this.showSuccessNotification(response.data.message, "");
          let id = response.data.insurance_id;
          this.$router.push("/devis-en-ligne-assurance-view/" + id);
        })
        .catch(error => {
          this.isSending = false;
          this.errors = error.response.data;

          // if (Array.isArray(error.response.data.errors)) {
          //     console.log('IS ARRAY');
          //     console.log(error.response.data.errors);
          //     this.errors.errors = {};
          //     if (error.response.data.errors.length === 1) {
          //         this.errors.errors.error = error.response.data.errors;
          //     }
          //     else {
          //         for (let i in error.response.data.errors) {
          //             this.errors.errors[`err_${i}`] = [error.response.data.errors[i]];
          //         }
          //     }
          // }
          // else {
          //     this.errors = error.response.data;
          // }

          if (
            error.response.data.exception ===
            "App\\Exceptions\\PriceErrorException"
          ) {
            this.errors.errors = {};
            this.errors.errors.error = [error.response.data.message];
          }
        });
    },
    getGuarantyInfo() {
      let url = "garantie/info-assurance/" + this.$route.params.id;
      this.apiGet(url)
        .then(response => {
          this.garantieCampingCar = this.parseQuoteData(
            response.data.insurance
          );
        })
        .catch(error => {
          console.log(error);
        });
    },
    parseClientInfo(client) {
      this.garantieCampingCar.civilite = client.civility;
      this.garantieCampingCar.nom = client.last_name;
      this.garantieCampingCar.prenom = client.first_name;
      this.garantieCampingCar.name_of_signatory = client.name_of_signatory;
      this.garantieCampingCar.adresse = client.address;
      this.garantieCampingCar.cp = client.zip;
      this.garantieCampingCar.ville = client.city;
      this.garantieCampingCar.tel = client.tel;
      this.garantieCampingCar.email = client.email;
      this.garantieCampingCar.fax = client.fax;
      this.garantieCampingCar.id_client = client.id;
    },
    parseQuoteData(quote) {
      // active: 1
      // address: "astreer, 1232"
      // assistance: 1
      // assure: "Oui"
      // bonus: 0
      // car_brand: "FIAT"
      // car_fuel: 2
      // category: "1"
      // civility: "0"
      // client: null
      // cp: "23322"
      // created_at: "2022-03-28 09:45:53"
      // cylinder: 1
      // date_circulation: "1614211200"
      // date_naissance: "138499200"
      // date_permis: "872553600"
      // day_circulation: 25
      // effective_date: "2022-03-30 09:45:53"
      // effective_date_end: "2023-03-29 09:45:53"
      // email: "dvndfvydfvgd9fduiv@mailer.com"
      // family: 1
      // fax: null
      // first_name: "preniome"
      // fiscal_power: 8
      // guarantee: null
      // guarantee_number: null
      // id: 109
      // id_client: 0
      // insurance_number: 7000099
      // is_pdf: 0
      // last_name: "nome"
      // marque_porteur: "FIAT"
      // mechanic: {id: 436, code: "1995", garage: "testcp", address: "test adresse", address_details: null, zip: "89009",…}
      // mechanic_id: 436
      // model: "DUCATO"
      // modele_porteur: "DUCATO"
      // month_circulation: 2
      // new: 1
      // origin: "dynassurances"
      // payment_id: null
      // payment_type: null
      // price: 1073.36
      // price_text: ""
      // profession: 5
      // ptc: 1
      // ptc_exact: null
      // registration: "FX-404-KR"
      // serial_number: "ZFA25000002R12281"
      // tel: "9099878776"
      // type: null
      // type_vehicle: 1
      // updated_at: "2022-03-28 09:45:53"
      // valeur: "75344"
      // ville: "city of client"
      // year_circulation: 2021

      let parsedQuote = {};

      parsedQuote.civilite = quote.civility;
      parsedQuote.nom = quote.last_name;
      parsedQuote.prenom = quote.first_name;
      parsedQuote.adresse = quote.address;
      parsedQuote.cp = quote.cp;
      parsedQuote.ville = quote.ville;
      parsedQuote.tel = quote.tel;
      parsedQuote.email = quote.email;
      parsedQuote.id_client = quote.id_client;
      parsedQuote.fax = quote.fax;
      parsedQuote.situation_famille = quote.family;
      parsedQuote.profession = quote.profession;
      parsedQuote.is_new = quote.new ? "Oui" : "Non";

      parsedQuote.immatriculation = quote.registration;
      // parsedQuote.immatriculation_ancien_numero = quote.registration_old_number;
      parsedQuote.marque_porteur = quote.marque_porteur;
      parsedQuote.modele_porteur = quote.modele_porteur;
      parsedQuote.ptc = quote.ptc;
      parsedQuote.valeur = quote.valeur;

      parsedQuote.jour_mise_en_circulation = quote.day_circulation;
      parsedQuote.mois_mise_en_circulation = quote.month_circulation;
      parsedQuote.annee_mise_en_circulation = quote.year_circulation;

      this.circulationDateInput = new Date(
        quote.year_circulation,
        quote.month_circulation - 1,
        quote.day_circulation
      );

      parsedQuote.num_serie = quote.serial_number;
      parsedQuote.puis_fisc = quote.fiscal_power;
      parsedQuote.assure = quote.assure;
      parsedQuote.assistance = quote.assistance;
      parsedQuote.bonus = quote.bonus;

      this.effectiveDateInput = new Date(quote.effective_date);

      if (quote.date_naissance) {
        let date_naissance = this.moment(+quote.date_naissance * 1000);
        this.dateDeNaissanceInput = new Date(+quote.date_naissance * 1000);
        this.garantieCampingCar.jour_naissance = date_naissance.format("D");
        this.garantieCampingCar.mois_naissance = date_naissance.format("M");
        this.garantieCampingCar.annee_naissance = date_naissance.format("YYYY");
      }

      if (quote.date_permis) {
        let date_permis = this.moment(+quote.date_permis * 1000);
        this.dateDePermisInput = new Date(+quote.date_permis * 1000);
        this.garantieCampingCar.jour_permis = date_permis.format("D");
        this.garantieCampingCar.mois_permis = date_permis.format("M");
        this.garantieCampingCar.annee_permis = date_permis.format("YYYY");
      }

      this.acceptedVehicleResult = true;
      return parsedQuote;
    },
    validateEffectiveDate() {
      if (!this.effectiveDateInput) return false;
      let date = this.moment(this.effectiveDateInput);

      this.garantieCampingCar.jour_prise_effet = date.format("D");
      this.garantieCampingCar.mois_prise_effet = date.format("M");
      this.garantieCampingCar.annee_prise_effet = date.format("YYYY");

      return true;
    },
    resetEffectiveDate() {
      this.garantieCampingCar.jour_prise_effet = 1;
      this.garantieCampingCar.mois_prise_effet = 1;
      this.garantieCampingCar.annee_prise_effet = 1970;
    },
    cleanEffectiveDate() {
      this.garantieCampingCar.jour_prise_effet = "";
      this.garantieCampingCar.mois_prise_effet = "";
      this.garantieCampingCar.annee_prise_effet = "";
    },
    validateCirculationDate() {
      if (!this.circulationDateInput) return false;
      let date = this.moment(this.circulationDateInput);

      this.garantieCampingCar.jour_mise_en_circulation = date.format("D");
      this.garantieCampingCar.mois_mise_en_circulation = date.format("M");
      this.garantieCampingCar.annee_mise_en_circulation = date.format("YYYY");

      return true;
    },
    validateNaissanceDate() {
      if (!this.dateDeNaissanceInput) return false;
      let date = this.moment(this.dateDeNaissanceInput);

      this.garantieCampingCar.jour_naissance = date.format("D");
      this.garantieCampingCar.mois_naissance = date.format("M");
      this.garantieCampingCar.annee_naissance = date.format("YYYY");

      return true;
    },
    validatePermisDate() {
      if (!this.dateDePermisInput) return false;
      let date = this.moment(this.dateDePermisInput);

      this.garantieCampingCar.jour_permis = date.format("D");
      this.garantieCampingCar.mois_permis = date.format("M");
      this.garantieCampingCar.annee_permis = date.format("YYYY");

      return true;
    },
    resetCirculationDate() {
      this.garantieCampingCar.jour_mise_en_circulation = "";
      this.garantieCampingCar.mois_mise_en_circulation = "";
      this.garantieCampingCar.annee_mise_en_circulation = "";
    },
    getListOfDurationOprions() {
      let list = [],
        options = document.getElementById("durationSelect").options;

      for (let option of options) {
        list.push(+option.value);
      }

      return list;
    },
    showAssistanceDetails() {
      let win = window.open(
        "http://dynassurances.fr/camping-car/assistance-pack.php",
        "_blank"
      );
      win.focus();
    },
    hasError(field) {
      return !!(this.errors.errors && this.errors.errors[field]);
    }
  },
  beforeRouteLeave(to, from, next) {
    this.garantieCampingCar = INITIAL_FIELDS_VALUES;
    next();
  },
  mounted() {
    if (this.$route.params.id) this.getGuarantyInfo();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Garantie/DealerInsuranceCampingCar/DevisEnLigneAssurance.vue